import { SxProps, Theme } from '@mui/material';

export const pageContainer: SxProps<Theme> = {
  p: 4,
  minWidth: 0,
  maxWidth: '100%',
};

export const headerSection: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  mb: 3,
};

export const pageTitle: SxProps<Theme> = {
  fontWeight: 600,
  flexShrink: 0,
};

// Search field sits on the heading's row and grows to fill the remaining
// width. Its control height is pinned to the h4 text line-box (34px ×
// 123.5% ≈ 42px) so the box never stands taller than the "Catalog" heading.
export const headerSearch: SxProps<Theme> = {
  flex: 1,
  '& .MuiOutlinedInput-root': { height: 42 },
  '& .MuiOutlinedInput-input': { py: 0 },
};

export const searchAndFilters: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  mb: 3,
};

export const errorPaper: SxProps<Theme> = {
  p: 2,
  mb: 2,
};

export const paginationWrapper: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 1,
};
